module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002-fr.e8d00f0.png";